<template>
  <div>
    <div class="w-full">
      <vs-alert class="mb-5" :active.sync="active1" icon-pack="feather" color="warning" icon="icon-alert-circle">
        Please select a Course, followed by a Module to view the linked documents.
      </vs-alert>
      <vx-card id="courseCard" title="Courses">

        <vs-table stripe ref="courseTable" class="vs-con-loading__container" single @selected="handleSelectedCourse" pagination max-items="10" search :data="courses" v-scroll-to="'#moduleCard'">

          <template slot="thead">
            <vs-th sort-key="name">Name</vs-th>
            <vs-th sort-key="description">Description</vs-th>
            <vs-th sort-key="modifiedOn">Modified On</vs-th>
            <vs-th sort-key="modifiedBy">Modified By</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="course" :key="indextr" v-for="(course, indextr) in data">

              <vs-td :data="data[indextr].name">
                {{ course.name }}
              </vs-td>

              <vs-td :data="data[indextr].description">
                {{ course.description }}
              </vs-td>

              <vs-td :data="data[indextr].modifiedOn">
                {{ course.modifiedOn.replace("T", " ").split('.')[0] }}
              </vs-td>

              <vs-td :data="data[indextr].modifiedBy">
                {{ course.modifiedBy }}
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
    <div v-show="!isHiddenModule" class="mt-8">
      <vx-card id="moduleCard" title="Modules">
        <vs-table stripe ref="moduleTable" class="vs-con-loading__container" single @selected="handleSelectedModule" pagination max-items="10" search :data="modules">

          <template slot="thead">
            <vs-th sort-key="id">ID</vs-th>
            <vs-th sort-key="name">Name</vs-th>
            <vs-th sort-key="description">Description</vs-th>
            <vs-th sort-key="modifiedOn">Modified On</vs-th>
            <vs-th sort-key="modifiedOn">Modified By</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="mod" :key="indextr" v-for="(mod, indextr) in data">

              <vs-td :data="data[indextr].id">
                {{ mod.id }}
              </vs-td>

              <vs-td :data="data[indextr].name">
                {{ mod.name }}
              </vs-td>

              <vs-td :data="data[indextr].description">
                {{ mod.description }}
              </vs-td>

              <vs-td :data="data[indextr].modifiedOn">
                {{ mod.modifiedOn.replace("T", " ").split('.')[0] }}
              </vs-td>

              <vs-td :data="data[indextr].modiefiedBy">
                {{ mod.modifiedBy }}
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
    <div v-show="showDocs" class="mt-8">
      <vx-card id="documentCard" title="Documents">
        <vs-table ref="uploadsTable" single max-items="5" pagination :data="documents">
          <template slot="thead">
            <vs-th></vs-th>
            <vs-th sort-key="url">File Name</vs-th>
            <vs-th sort-key="moduleName">Document Type</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="uploadedFiles" :key="indextr" v-for="(file, indextr) in data">
              <vs-td>
                <a :href="file.url"><img :src="setFileThumb(file.url)" width=30px class="product-img" /></a>
              </vs-td>
              <vs-td>
                <a :href="file.url"><p class="product-name font-medium">{{ file.url.substring(file.url.lastIndexOf('/') + 1) }}</p></a>
              </vs-td>
              <vs-td>
                <a :href="file.url"><p class="product-name font-medium">{{ file.documentTypeName }}</p></a>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
  </div>

</template>

<script>
  export default {
    data() {
      return {
        selected: [],
        isHiddenModule: true,
        courses: [],
        modules: [],
        documents:[],
        active1: true,
        showDocs: false,
        selectedModule: 0,
        uploadedFiles: [],
      }
    },
    methods: {
      loadCourseData() {
        const self = this;

        var onSuccess = function (response) {
          self.courses = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.courseTable.$el);
          self.$refs.courseTable.searchx = "";
        };

        self.$ajaxGet(self, "course/AssessorListCourses", onSuccess, onFinally);
      },
      loadModuleData(id) {
        const self = this;

        var onSuccess = function(response) {
          self.modules = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.moduleTable.$el);
          self.$refs.moduleTable.searchx = "";
        };

        self.$ajaxGet(self, "module/AssessorListCourseModule/" + id, onSuccess, onFinally);
      },
      setFileThumb(url) {
        var ext = url.substring(url.lastIndexOf('.') + 1);
        if (ext.includes('mp3'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/music.jpg";
        else if (ext.includes('jpg') || ext.includes('jpeg') || ext.includes('png') || ext.includes('gif'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/image.png";
        else if (ext.includes('doc') || ext.includes('xls') || ext.includes('pdf') || ext.includes('ppt') || ext.includes('txt') || ext.includes('rtf'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/document.png";
        else if (ext.includes('mp4') || ext.includes('wmv') || ext.includes('mov') || ext.includes('webm') || ext.includes('x-matroska') || ext.includes('mkv'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/video.png";
      },
      listDocuments(moduleId) {
        const self = this;
        //self.showLoadingOnElement("uploadsTable", 1, "corners");

        var onSuccess = function (response) {
          self.documents = response.data;
        };
        var onFinally = function () {
          //self.$vs.loading.close(self.$refs.uploadsTable.$el);
          self.$refs.uploadsTable.searchx = "";
        };

        self.$ajaxGet(self, "Module/ListDocuments?moduleId=" + self.selectedModule, onSuccess, onFinally);
      },
      showLoadingOnElement(element, scale, type){
        var self = this;
        self.$vs.loading({
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      },
      handleSelectedCourse(course) {
        this.isHiddenModule = false;
        this.showLoadingOnModuleTable();
        this.loadModuleData(course.id);
      },
      handleSelectedModule(mod) {
        this.selectedModule = mod.id;
        this.listDocuments();
        this.showDocs = true;
        this.scrollToFooter();
      },
      showLoadingOnCourseTable(){
        var self = this;
        self.$vs.loading({
          type: "corners",
          container: self.$refs.courseTable.$el,
          scale: 1
        });
      },
      showLoadingOnModuleTable(){
        var self = this;
        self.$vs.loading({
          type: "corners",
          container: self.$refs.moduleTable.$el,
          scale: 1
        });
      },
      scrollToFooter() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -480,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("footerGlobal"), 100, scrollOptions);
      }
    },
    mounted() {
      this.showLoadingOnCourseTable();
      this.loadCourseData();
    },
  }

</script>
